import { useState } from 'react';
import { signIn, SignInOptions, SignInResponse, signOut, SignOutParams } from 'next-auth/react';

/**
 * Hook for next-auth signin
 */
export const useSignIn = (): {
  isLoading: boolean;
  error: Error;
  execute: (providerId: string, param: SignInOptions) => Promise<void | SignInResponse>;
} => {
  const [isLoading, setIsLoading] = useState(null);
  const [error, setError] = useState(null);

  const execute = (providerId: string, param: SignInOptions) => {
    setIsLoading(true);

    return signIn(providerId, param)
      .catch((error) => setError(error))
      .finally(() => setIsLoading(false));
  };

  return { isLoading, error, execute };
};

/**
 * Hook for next-auth signin
 */
export const useSignOut = (): {
  isLoading: boolean;
  error: Error;
  execute: (param?: SignOutParams) => Promise<void>;
} => {
  const [isLoading, setIsLoading] = useState(null);
  const [error, setError] = useState(null);

  const execute = (param?: SignOutParams) => {
    setIsLoading(true);

    return signOut(param)
      .catch((error) => setError(error))
      .finally(() => setIsLoading(false));
  };

  return { isLoading, error, execute };
};
